<template>
    <div id="favorite-accounts" v-if="this.userCan('view_dashboard_account_datatable', 'init') && hasAccounts">
        <div class="favorite-accounts-wrapper">
            <div class="columns component-header-actions">
                <div class="column">
                    <h4 class="title is-4">
                        <b-icon icon="star" type="is-warning" /> Favorite Accounts
                    </h4>
                </div>
            </div>

            <div class="account-rows-wrapper">
                <template v-if="!loadingAccounts">
                    <ul class="account-rows-header">
                        <li class="account-row-favorite"></li>
                        <li class="account-row-status">Status</li>
                        <li class="account-row-name">Account Name</li>
                        <li class="account-row-account">Account #</li>
                        <li class="account-row-data"></li>
                        <li class="account-row-buttons"></li>
                    </ul>
                    <account-row
                            v-for="account in accounts"
                            :key="`account-${account.id}`"
                            :account="account" />
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AccountRow from './AccountRow'

export default {
  name: 'FavoriteAccounts',
  props: ['accessible_accounts'],
  components: {
    AccountRow
  },
  computed: {
    ...mapState({
      init: state => state.init.all,
      accounts: state => state.accounts.favorites,
      userSettings: state => state.userSettings,
      accountsInitialized: state => state.accounts.initialized
    }),
    ...mapGetters({
      pusher: 'pusher/init',
      userCan: 'userCan'
    }),
    hasAccounts: function () {
      if (!this.accountsInitialized) return false
      return Object.keys(this.accounts).length > 0
    },
    loadingAccounts: function () {
      if (this.accountsInitialized) return false
      return !this.hasAccounts
    }
  },
  methods: {
    //
  },
  mounted () {
    //
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Account/Dashboard/Favorites.vue